import React, { memo } from 'react'

import { ArrowRight, Icon, InfoOutlined } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

/* import ExtraUsageCard from '../ExtraUsageCard/ExtraUsageCard' */
import ProgressBar from '../ProgressBar/ProgressBar'

const SUBSCRIPTION_SETTINGS_HREF = '/profile/settings#tab-settings-subscription'

function SubscribedBody({ onClose: handleClose }) {
  const monthlyUsed = useThreeDStudioStore(state => state.subscription.monthlyGenerationsUsed)
  const monthlyAvailable = useThreeDStudioStore(state => state.subscription.monthlyGenerationsAvailable)
  const extraUsed = useThreeDStudioStore(state => state.subscription.extraGenerationsUsed)
  const extraAvailable = useThreeDStudioStore(state => state.subscription.extraGenerationsAvailable)
  const resetDate = useThreeDStudioStore(state => state.subscription.subscriptionResetDate)

  const isOutOfMonthly = monthlyAvailable > 0 && monthlyUsed >= monthlyAvailable
  const showExtraBar = extraUsed > 0 || extraAvailable > 0

  return (
    <div className="usage-modal__subscribed">
      {isOutOfMonthly && (
        <p className="usage-modal__warning-headline cgt-heading-200">
          You&apos;re out of generations
        </p>
      )}

      <div className="usage-modal__subscribed-content">
        <ProgressBar
          label="Monthly Generations used"
          used={monthlyUsed}
          total={monthlyAvailable}
        />

        {resetDate && (
          <div className="usage-modal__inline-info cgt-body-base">
            <Icon
              svgComponent={InfoOutlined}
              color="dark"
              size="small"
              notSpaced
              className="usage-modal__inline-info-icon"
            />
            <span className="usage-modal__reset-date">
              Reset date: <span className="usage-modal__reset-date cgt-caption-semibold">{resetDate}</span>
            </span>
          </div>
        )}

        {showExtraBar && (
          <ProgressBar
            label="Extra Generations used"
            used={extraUsed}
            total={extraAvailable}
          />
        )}

        {/* Enable when top-ups are enabled */}
        {/* <ExtraUsageCard onClose={handleClose} /> */}

        <a
          className="usage-modal__footer-link cgt-link-primary cgt-body-md-semibold"
          href={SUBSCRIPTION_SETTINGS_HREF}
          onClick={handleClose}
        >
          <span>Go to Subscription Settings</span>
          <Icon
            svgComponent={ArrowRight}
            color="primary"
            size="small"
            notSpaced
          />
        </a>
      </div>
    </div>
  )
}

SubscribedBody.propTypes = {
  onClose: func.isRequired,
}

export default memo(SubscribedBody)
